import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { Paragraph, useWindowSize } from 'heliocor-ui'

import { STRUCTURE_COLUMNS, STRUCTURE_LOOKUP } from './table'
import LightTable from '../../common/LightTable/LightTable'
import { CommonTitle } from '../../common'
import { useTranslation } from 'react-i18next';

const StructureTables = ({
    data, handler, extraContent, handleDelete, handleEdit, handleDeleteLookupSuggestion, mainTitle
}) => {

    const { t } = useTranslation()
    const errors = useSelector(state => state.party.postErrors)
    const lookupStructureData = useSelector(state => state.party.lookupStructureData)
    const { isMobile } = useWindowSize()

    const props = { handleEdit, handler }

    const { translateSuggestedStructure = '' } = mainTitle

    const mapToStructureTable = (data) => {
        let tableStructure = [];

        const appendChildren = (level) => {
            const currentLevelCPs = data.filter(cp => cp.level === level)
            if(!currentLevelCPs.length) return tableStructure
            if(level === 0) {
                tableStructure = [...currentLevelCPs]
                appendChildren(level + 1)
            } else {
                currentLevelCPs.forEach(cp => {
                    const parentIndex = tableStructure.findIndex(parent => parent.identifier === cp.parentId)
                    tableStructure.splice(parentIndex + 1, 0, cp)
                })
                appendChildren(level + 1)
            }
        }

        appendChildren(0)
        return tableStructure
    }

    return (
        <Fragment>
            <CommonTitle
                translate={mainTitle.title}
                subtitle={{ component: <Paragraph>{`${t(mainTitle.subtitle.id, mainTitle.subtitle.data)} ${t(translateSuggestedStructure)}`}</Paragraph> }}
                height='auto'
            />
            <LightTable
                {...props}
                data={mapToStructureTable(data)}
                handleDelete={handleDelete}
                columns={STRUCTURE_COLUMNS(t, isMobile, errors)}
                extraContent={extraContent}
            />
            {!isEmpty(lookupStructureData) &&
                <LightTable
                    {...props}
                    title='suggestedStructure'
                    handleDelete={handleDeleteLookupSuggestion}
                    data={lookupStructureData}
                    columns={STRUCTURE_LOOKUP(t, isMobile)}
                    margin='0 0 2rem 0'
                    alternColorOverride='aqua100'
                />
            }
        </Fragment>
    )
}

export { StructureTables }